import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';
import config from '../../../config';
import NdoeSpinner from '../../../components/ndoe/NdoeSpinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Skeleton } from 'antd';
import './formCommande.css'
import '../../products/form/productForm.scss'   // styles des champs (.form-controle/.form-input)
import { NdoeFormSection, NdoeActionButton } from '../../../components/ndoe';
import { useFormGuard } from '../../../utils/formGuard';

const FormCommande = ({fetchData, closeModal}) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const [province, setProvince] = useState([]);
  const [getClient, setGetClient] = useState([]);
  const [checkeds, setCheckeds] = useState(false);
  const [idProvince, setIdProvince] = useState([]);
  const [commune, setCommune] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [adresseOne, setAdresseOne] = useState([]);
  const [adresseId, setAdresseId] = useState([]);
  const [telephone, setTelephone] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [shops, setShops] = useState([]); // référentiel boutiques (chantier #2)

  // Ajout inline d'un téléphone / d'une adresse pour la cliente DÉJÀ sélectionnée
  // (cas : commande passée depuis un numéro / une adresse non encore enregistrés).
  const [showAddTel, setShowAddTel] = useState(false);
  const [newTel, setNewTel] = useState('');
  const [savingTel, setSavingTel] = useState(false);
  const [showAddAdr, setShowAddAdr] = useState(false);
  const [newAdr, setNewAdr] = useState({ id_ville: '', id_commune: '', avenue: '', quartier: '', num: '' });
  const [newAdrCommunes, setNewAdrCommunes] = useState([]);
  const [savingAdr, setSavingAdr] = useState(false);

  const initialData = {
    id_client: '',
    id_shop: '',
    id_adresse: '',
    id_telephone: '',
    nom: '',
    raison_sociale: '',
    email: '',
    telephone: '',
    id_province: '',
    id_commune: '',
    avenue: '',
    quartier: '',
    num: '',
  };

  const resetForm = () => {
    setData(initialData);
    setCheckeds(false);
    setIdProvince([]);
    setCommune([]);
  };

  // Garde « formulaire modifié » : consultée par le chevron retour, le Back
  // Android et beforeunload. Retombe après soumission (resetForm vide data).
  useFormGuard(Boolean(data.id_client || data.nom || data.id_adresse || data.id_telephone));

  const handleInputChange = (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    let updatedValue = fieldValue;

    if (fieldName === "contact_email") {
      updatedValue = fieldValue.toLowerCase();
    } else if (Number.isNaN(Number(fieldValue))) {
      updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
    }

    setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
  };

  const handleConfirm = () => {
    setConfirmVisible(true);
  };

  const handleOk = async () => {
    setConfirmVisible(false);
    handleSubmit();
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      setIsLoading(true);
      const res = await axios.post(`${DOMAIN}/api/commande/commandePost`, data);
      toast.success('Commande créée avec succès!');
      // Vider le formulaire seulement APRÈS un enregistrement réussi. Ce geste
      // était dans le `finally` : la moindre coupure 3G effaçait la commande
      // que la secrétaire venait de saisir (cliente, adresse, téléphone), juste
      // au moment où la ressaisir coûte le plus cher. Elle garde maintenant sa
      // saisie et n'a qu'à retoucher le bouton.
      resetForm();
      fetchData?.();
      if (closeModal) {
        closeModal();
      } else if (res.data?.id_commande) {
        // Mode page (/commandeForm, sans props) : enchaîner directement sur
        // l'ajout des articles de la commande fraîchement créée.
        navigate(`/commandes/${res.data.id_commande}`);
      } else {
        navigate('/listeCommande');
      }
    } catch (err) {
      // err.message d'axios vaut « Request failed with status code 400 » :
      // le motif français renvoyé par le serveur est dans la réponse.
      toast.error(
        err?.response?.data?.error
          || err?.response?.data?.message
          || `La commande n'a pas pu être enregistrée : ${err.message}`,
      );
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  const handleClick2 = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    // Garde de saisie : le serveur exige nom + téléphone (et détecte les doublons).
    if (!String(data.nom || '').trim()) { toast.warning('Le nom de la cliente est obligatoire.'); return; }
    if (!String(data.telephone || '').trim()) { toast.warning('Le téléphone de la cliente est obligatoire.'); return; }

    // Le bouton se verrouille AVANT la vérification réseau : sinon, pendant
    // l'aller-retour, un second clic lançait une deuxième création (le
    // verrouillage n'arrivait qu'après). Toutes les sorties ci-dessous
    // relâchent le verrou.
    setIsSubmitting(true);

    // Numéro déjà connu ? (demande proprio 20/07 — plusieurs personnes peuvent
    // partager un numéro : on ALERTE, on n'interdit jamais.) Trois issues :
    // utiliser la cliente existante (c'est la même personne), créer quand même
    // (numéro partagé), ou annuler pour corriger la saisie.
    try {
      const { data: dup } = await axios.get(`${DOMAIN}/api/client/recherche/par-telephone`, {
        params: { numero: data.telephone },
      });
      const matches = dup?.clientes || [];
      if (matches.length) {
        const Swal = (await import('sweetalert2')).default;
        const options = {};
        matches.forEach((m) => {
          options[m.id] = `${m.nom} — ${m.telephone || ''}${m.commandes ? ` (${m.commandes} cmde${m.commandes > 1 ? 's' : ''})` : ''}`;
        });
        const choix = await Swal.fire({
          title: 'Numéro déjà enregistré',
          html: `<p style="margin:0 0 8px">Ce téléphone appartient déjà à ${matches.length > 1 ? 'des clientes' : 'une cliente'}. Est-ce la même personne ?</p>`,
          input: 'radio',
          inputOptions: options,
          inputValue: String(matches[0].id),
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'C’est elle → utiliser cette cliente',
          denyButtonText: 'Autre personne → créer quand même',
          cancelButtonText: 'Annuler',
          confirmButtonColor: '#1f7a4d',
        });
        if (choix.isConfirmed) {
          const idExistant = Number(choix.value);
          if (idExistant) {
            handleInputChange({ target: { name: 'id_client', value: idExistant } });
            setData((prev) => ({
              ...prev,
              nom: '', raison_sociale: '', email: '', telephone: '',
              id_province: '', commune: '', avenue: '', quartier: '', num: '',
            }));
            setCheckeds(false);
            toast.success('Cliente existante sélectionnée — aucun doublon créé.');
          }
          setIsSubmitting(false);
          return;
        }
        if (!choix.isDenied) { setIsSubmitting(false); return; }   // Annuler → retour à la saisie.
        // isDenied → numéro partagé assumé : la création continue ci-dessous.
      }
    } catch (e) { /* la vérification est un filet — une panne ne bloque pas la création */ }

    try {
      // Le backend attend id_commune (cf. ClientForm) ; le select écrit data.commune -> on remappe.
      const res = await axios.post(`${DOMAIN}/api/client/client`, { ...data, id_commune: data.commune });
      const nouvelId = res.data?.id_client;

      // Recharge la liste puis SÉLECTIONNE la cliente créée (demande proprio 18/07) :
      // plus de navigate (qui rechargeait tout le formulaire et perdait le contexte).
      const { data: liste } = await axios.get(`${DOMAIN}/api/client`);
      setGetClient(liste);
      if (nouvelId) {
        handleInputChange({ target: { name: 'id_client', value: nouvelId } });
      }

      // Vide les champs de saisie de la nouvelle cliente pour ne pas les traîner
      // (id_client vient d'être posé ci-dessus, on le préserve).
      setData((prev) => ({
        ...prev,
        nom: '', raison_sociale: '', email: '', telephone: '',
        id_province: '', commune: '', avenue: '', quartier: '', num: '',
      }));

      setCheckeds(false); // ferme la popup
      toast.success('Cliente créée et sélectionnée.');
    } catch (err) {
      // Message serveur en priorité (ex. « Le client existe déjà… »).
      toast.error(
        err?.response?.data?.message
          || err?.response?.data?.error
          || `La cliente n'a pas pu être créée : ${err.message}`,
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/client`);
        setGetClient(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchClient();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchProvince = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/livreur/province`);
        setProvince(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProvince();
  }, [DOMAIN]);

  // Boutiques (chantier #2) : sélecteur au lieu d'un texte libre. Pré-sélection de
  // la boutique par défaut (ou de l'unique boutique) pour ne rien saisir dans le cas courant.
  useEffect(() => {
    const fetchShops = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/shop`);
        const list = Array.isArray(data) ? data : [];
        setShops(list);
        const defaut = list.find((s) => s.par_defaut) || (list.length === 1 ? list[0] : null);
        if (defaut) setData((prev) => (prev.id_shop ? prev : { ...prev, id_shop: defaut.id_shop }));
      } catch (error) { console.log(error); }
    };
    fetchShops();
  }, [DOMAIN]);

  useEffect(() => {
    setIdProvince(data?.id_province);
    setAdresseId(data?.id_client);
  }, [data?.id_province, data?.id_client]);

  useEffect(() => {
    const fetchCommune = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/livreur/commune/${idProvince}`);
        setCommune(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCommune();
  }, [DOMAIN, idProvince]);

  // Fetchers réutilisables (appelés par les effets ET après un ajout inline).
  const fetchAdresse = useCallback(async (clientId) => {
    const cid = Number(clientId);
    if (!cid) { setAdresseOne([]); return []; }
    try {
      const { data } = await axios.get(`${DOMAIN}/api/client/clientAdresse/${cid}`);
      const list = Array.isArray(data) ? data : [];
      setAdresseOne(list);
      return list;
    } catch (error) { console.log(error); return []; }
  }, [DOMAIN]);

  const fetchTelephone = useCallback(async (clientId) => {
    const cid = Number(clientId);
    if (!cid) { setTelephone([]); return []; }
    try {
      const { data } = await axios.get(`${DOMAIN}/api/client/clientTelephone/${cid}`);
      const list = Array.isArray(data) ? data : [];
      setTelephone(list);
      return list;
    } catch (error) { console.log(error); return []; }
  }, [DOMAIN]);

  useEffect(() => { fetchAdresse(adresseId); }, [fetchAdresse, adresseId]);
  useEffect(() => { fetchTelephone(adresseId); }, [fetchTelephone, adresseId]);

  // Communes du formulaire d'ajout d'adresse inline (découplé du bloc « nouveau client »).
  useEffect(() => {
    if (!newAdr.id_ville) { setNewAdrCommunes([]); return; }
    const load = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/livreur/commune/${newAdr.id_ville}`);
        setNewAdrCommunes(Array.isArray(data) ? data : []);
      } catch (error) { console.log(error); }
    };
    load();
  }, [DOMAIN, newAdr.id_ville]);

  // Ajoute un numéro à la cliente sélectionnée, recharge la liste et le sélectionne.
  const handleAddTelephone = async () => {
    if (!data.id_client) { toast.error('Sélectionnez d’abord une cliente.'); return; }
    const numero = String(newTel || '').trim();
    if (!numero) { toast.error('Saisissez un numéro.'); return; }
    setSavingTel(true);
    try {
      await axios.post(`${DOMAIN}/api/client/clientTelephone`, { id_client: data.id_client, numero });
      const list = await fetchTelephone(data.id_client);
      const created = [...list].reverse().find((t) => String(t.numero) === numero) || list[list.length - 1];
      if (created) handleInputChange({ target: { name: 'id_telephone', value: created.id_telephone } });
      setNewTel('');
      setShowAddTel(false);
      toast.success('Numéro ajouté.');
    } catch (err) {
      toast.error(`Erreur: ${err.response?.data?.error || err.message}`);
    } finally {
      setSavingTel(false);
    }
  };

  // Ajoute une adresse à la cliente sélectionnée, recharge la liste et la sélectionne.
  const handleAddAdresse = async () => {
    if (!data.id_client) { toast.error('Sélectionnez d’abord une cliente.'); return; }
    if (!newAdr.id_ville || !newAdr.id_commune) { toast.error('Ville et commune sont requises.'); return; }
    setSavingAdr(true);
    try {
      await axios.post(`${DOMAIN}/api/client/clientAdresse`, {
        id_client: data.id_client,
        id_ville: newAdr.id_ville,
        id_commune: newAdr.id_commune,
        avenue: newAdr.avenue || '',
        quartier: newAdr.quartier || '',
        num: newAdr.num || '',
        ref: null,
      });
      const list = await fetchAdresse(data.id_client);
      const created = list.reduce((a, b) => (a && Number(a.id_adresse) > Number(b.id_adresse) ? a : b), null);
      if (created) handleInputChange({ target: { name: 'id_adresse', value: created.id_adresse } });
      setNewAdr({ id_ville: '', id_commune: '', avenue: '', quartier: '', num: '' });
      setNewAdrCommunes([]);
      setShowAddAdr(false);
      toast.success('Adresse ajoutée.');
    } catch (err) {
      toast.error(`Erreur: ${err.response?.data?.error || err.message}`);
    } finally {
      setSavingAdr(false);
    }
  };


  const linkBtn = { background: 'none', border: 'none', color: '#b8860b', cursor: 'pointer', fontSize: 12, padding: 0, fontWeight: 600 };

  return (
    <div className="clientForm">
      <Modal
        title="Confirmer la commande"
        open={confirmVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirmer"
        cancelText="Annuler"
        className="confirmation-modal"
      >
        <p className="modal-text">Êtes-vous sûr de vouloir soumettre cette commande avec les informations suivantes ?</p>
        <ul className="modal-data">
          <li>Client: {getClient.find(client => client.id === data.id_client)?.nom || 'N/A'}</li>
          <li>Boutique: {shops.find(s => s.id_shop === data.id_shop)?.nom || 'N/A'}</li>
          <li>Adresse: {adresseOne.find(adresse => adresse.id_adresse === data.id_adresse)?.nom_province}, {adresseOne.find(adresse => adresse.id_adresse === data.id_adresse)?.nom_commune || 'N/A'}</li>
          <li>Téléphone: {telephone.find(tel => tel.id_telephone === data.id_telephone)?.numero || 'N/A'}</li>
        </ul>
      </Modal>

      {/* Fenêtre dédiée — ajouter un NUMÉRO à la cliente sélectionnée (pensée mobile). */}
      <Modal
        title="Ajouter un numéro"
        open={showAddTel}
        onOk={handleAddTelephone}
        onCancel={() => { setShowAddTel(false); setNewTel(''); }}
        okText="Ajouter le numéro"
        cancelText="Annuler"
        confirmLoading={savingTel}
        okButtonProps={{ disabled: !String(newTel).trim() }}
        className="ndoe-form-modal"
        destroyOnClose
      >
        <div className="form-controle">
          <label>Numéro de téléphone</label>
          <input type="tel" className="form-input" placeholder="Ex. 08XXXXXXXX" value={newTel} onChange={(e) => setNewTel(e.target.value)} autoFocus />
        </div>
      </Modal>

      {/* Fenêtre dédiée — ajouter une ADRESSE spéciale à la cliente sélectionnée (pensée mobile). */}
      <Modal
        title="Ajouter une adresse"
        open={showAddAdr}
        onOk={handleAddAdresse}
        onCancel={() => { setShowAddAdr(false); setNewAdr({ id_ville: '', id_commune: '', avenue: '', quartier: '', num: '' }); setNewAdrCommunes([]); }}
        okText="Enregistrer l’adresse"
        cancelText="Annuler"
        confirmLoading={savingAdr}
        okButtonProps={{ disabled: !newAdr.id_ville || !newAdr.id_commune }}
        className="ndoe-form-modal"
      >
        <div className="ndoe-form-grid">
          <div className="form-controle">
            <label>Ville / province</label>
            <Select
              placeholder="Ville / province"
              menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              options={province?.map(item => ({ value: item.id_province, label: item.nom_province }))}
              value={province.filter(p => p.id_province === newAdr.id_ville).map(p => ({ value: p.id_province, label: p.nom_province }))[0] || null}
              onChange={opt => setNewAdr(prev => ({ ...prev, id_ville: opt.value, id_commune: '' }))}
            />
          </div>
          <div className="form-controle">
            <label>Commune</label>
            <Select
              placeholder="Commune"
              menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              options={newAdrCommunes?.map(item => ({ value: item.id_commune, label: item.nom_commune }))}
              value={newAdrCommunes.filter(c => c.id_commune === newAdr.id_commune).map(c => ({ value: c.id_commune, label: c.nom_commune }))[0] || null}
              onChange={opt => setNewAdr(prev => ({ ...prev, id_commune: opt.value }))}
            />
          </div>
          <div className="form-controle">
            <label>Avenue</label>
            <input type="text" className="form-input" value={newAdr.avenue} onChange={e => setNewAdr(prev => ({ ...prev, avenue: e.target.value }))} />
          </div>
          <div className="form-controle">
            <label>Quartier</label>
            <input type="text" className="form-input" value={newAdr.quartier} onChange={e => setNewAdr(prev => ({ ...prev, quartier: e.target.value }))} />
          </div>
          <div className="form-controle">
            <label>N°</label>
            <input type="number" className="form-input" value={newAdr.num} onChange={e => setNewAdr(prev => ({ ...prev, num: e.target.value }))} />
          </div>
        </div>
      </Modal>

      <div style={{ marginBottom: 14 }}>
        <div className="ndoe-eyebrow">Commerce</div>
        <h2 className="ndoe-page-title" style={{ fontSize: 20 }}>Nouvelle commande</h2>
        <p className="ndoe-page-subtitle">Sélectionnez la cliente et son adresse de livraison</p>
      </div>

      <NdoeFormSection step={1} title="Cliente & livraison" hint="Client, boutique, adresse, téléphone" collapsible={false}>
        <div className="ndoe-form-grid">
          <div className="form-controle ndoe-form-grid--full">
            <label>Client <span style={{ color: 'red' }}>*</span></label>
            {getClient.length === 0 ? (
              <Skeleton.Input active block />
            ) : (
              <Select
                placeholder="Sélectionnez un(e) client(e)"
                name="id_client"
                /* Libellé = nom + téléphone : taper des CHIFFRES retrouve la
                   cliente par son numéro (demande proprio 20/07). */
                value={data.id_client ? { value: data.id_client, label: (() => { const c = getClient.find(client => client.id === data.id_client); return c ? (c.telephone ? `${c.nom} — ${c.telephone}` : c.nom) : ''; })() } : null}
                options={getClient?.map(item => ({ value: item.id, label: item.telephone ? `${item.nom} — ${item.telephone}` : item.nom }))}
                /* Filtre maison : le filtre par défaut cherche une sous-chaîne
                   EXACTE, donc taper « 0854… » ne trouvait pas « +243854… ».
                   Ici le nom se cherche en texte, le numéro en CHIFFRES seuls. */
                filterOption={(option, saisie) => {
                  const q = String(saisie || '').trim();
                  if (!q) return true;
                  const label = String(option.label || '').toLowerCase();
                  if (label.includes(q.toLowerCase())) return true;
                  const qNum = q.replace(/\D/g, '');
                  return qNum.length >= 3 && String(option.label || '').replace(/\D/g, '').includes(qNum);
                }}
                onChange={selectedOption => handleInputChange({ target: { name: 'id_client', value: selectedOption.value } })}
              />
            )}
            {getClient.length > 0 && (
              <button type="button" style={{ ...linkBtn, marginTop: 8 }} onClick={() => setCheckeds(true)}>
                ➕ Nouvelle cliente
              </button>
            )}
          </div>

          <div className="form-controle">
            <label>Boutique <span style={{ color: 'red' }}>*</span></label>
            {shops.length === 0 ? (
              <Skeleton.Input active block />
            ) : (
              <Select
                placeholder="Choisir la boutique"
                name="id_shop"
                value={data.id_shop ? { value: data.id_shop, label: shops.find(s => s.id_shop === data.id_shop)?.nom } : null}
                options={shops.map(s => ({ value: s.id_shop, label: s.nom + (s.commune ? ` — ${s.commune}` : '') }))}
                onChange={opt => handleInputChange({ target: { name: 'id_shop', value: opt.value } })}
              />
            )}
          </div>

          <div className="form-controle">
            <label>Adresse <span style={{ color: 'red' }}>*</span></label>
            {getClient.length === 0 ? (
              <Skeleton.Input active block />
            ) : (
              <Select
                name="id_adresse"
                value={data.id_adresse ? { value: data.id_adresse, label: adresseOne.find(item => item.id_adresse === data.id_adresse)?.nom_province + ' de ' + ' C/' + adresseOne.find(item => item.id_adresse === data.id_adresse)?.nom_commune + ' Av/' + adresseOne.find(item => item.id_adresse === data.id_adresse)?.avenue + ' Q/' + adresseOne.find(item => item.id_adresse === data.id_adresse)?.quartier + ' N°/' + adresseOne.find(item => item.id_adresse === data.id_adresse)?.num } : null}
                options={adresseOne?.map(item => ({ value: item.id_adresse, label: item.nom_province + ' de ' + ' C/' + item.nom_commune + ' Av/' + item.avenue + ' Q/' + item.quartier + ' N°/' + item.num }))}
                onChange={selectedOption => handleInputChange({ target: { name: 'id_adresse', value: selectedOption.value } })}
              />
            )}
            {data.id_client ? (
              <button type="button" style={{ ...linkBtn, marginTop: 6 }} onClick={() => setShowAddAdr(true)}>➕ Ajouter une adresse</button>
            ) : null}
          </div>

          <div className="form-controle ndoe-form-grid--full">
            <label>Téléphone <span style={{ color: 'red' }}>*</span></label>
            {getClient.length === 0 ? (
              <Skeleton.Input active block />
            ) : (
              <Select
                name="id_telephone"
                value={data.id_telephone ? { value: data.id_telephone, label: telephone.find(item => item.id_telephone === data.id_telephone)?.numero } : null}
                options={telephone?.map(item => ({ value: item.id_telephone, label: item.numero }))}
                onChange={selectedOption => handleInputChange({ target: { name: 'id_telephone', value: selectedOption.value } })}
              />
            )}
            {data.id_client ? (
              <button type="button" style={{ ...linkBtn, marginTop: 6 }} onClick={() => setShowAddTel(true)}>➕ Ajouter un numéro</button>
            ) : null}
          </div>

        </div>
      </NdoeFormSection>

      {/* Création d'une cliente EN POPUP (demande proprio 18/07) : la cliente
          créée est ensuite sélectionnée directement dans la commande (voir
          handleClick2). Auparavant, ce bloc s'affichait sous le formulaire et
          « Créer le client » rechargeait toute la page. */}
      <Modal
        title="Nouvelle cliente"
        open={checkeds}
        onCancel={() => setCheckeds(false)}
        footer={null}
        width={640}
        className="ndoe-form-modal"
        destroyOnClose
      >
        <div className="ndoe-form-modal-body">
          <div className="ndoe-form-grid">
            <div className="form-controle">
              <label>Nom</label>
              <input type="text" name='nom' className="form-input" onChange={handleInputChange} required />
            </div>
            <div className="form-controle">
              <label>Raison sociale</label>
              <select className="form-input" name="raison_sociale" onChange={handleInputChange} required defaultValue="">
                <option value="" disabled>Selectionnez une raison sociale</option>
                <option value="Client VIP">Client VIP</option>
                <option value="Client Normal">Client Normal</option>
              </select>
            </div>
            <div className="form-controle">
              <label>Email</label>
              <input type="email" name='email' className="form-input" onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>Téléphone</label>
              <input type="tel" name='telephone' className="form-input" onChange={handleInputChange} required />
            </div>
            <div className="form-controle">
              <label>Ville</label>
              <Select
                name="id_province"
                options={province?.map(item => ({ value: item.id_province, label: item.nom_province }))}
                onChange={selectedOption => handleInputChange({ target: { name: 'id_province', value: selectedOption.value } })}
              />
            </div>
            <div className="form-controle">
              <label>Commune</label>
              <Select
                name="id_commune"
                options={commune?.map(item => ({ value: item.id_commune, label: item.nom_commune }))}
                onChange={selectedOption => handleInputChange({ target: { name: 'commune', value: selectedOption.value } })}
              />
            </div>
            <div className="form-controle">
              <label>Avenue</label>
              <input type="text" name="avenue" className="form-input" onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>Quartier</label>
              <input type="text" name="quartier" className="form-input" onChange={handleInputChange} />
            </div>
            <div className="form-controle">
              <label>N°</label>
              <input type="number" name="num" className="form-input" onChange={handleInputChange} />
            </div>
          </div>
          <div style={{ marginTop: 16, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <NdoeActionButton variant="secondary" onClick={() => setCheckeds(false)}>Annuler</NdoeActionButton>
            <NdoeActionButton variant="ink" onClick={handleClick2} loading={isSubmitting} icon={isLoading ? <NdoeSpinner size={16} /> : null}>
              Créer et sélectionner
            </NdoeActionButton>
          </div>
        </div>
      </Modal>

      <div style={{ display: 'flex', gap: 10, marginTop: 16, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <NdoeActionButton variant="secondary" onClick={() => (closeModal ? closeModal() : navigate(-1))}>Annuler</NdoeActionButton>
        <NdoeActionButton
          variant="primary"
          onClick={handleConfirm}
          loading={isLoading || isSubmitting}
          icon={isLoading ? <NdoeSpinner size={16} /> : null}
        >
          Envoyer
        </NdoeActionButton>
      </div>
    </div>
  );
}

export default FormCommande;
